"use strict";
/*
 * Created on 09.05.2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var IntegerValidator_1 = require("../../core/model/data-dictionary/validators/IntegerValidator");

var NumberGreaterThanValidator_1 = require("../../core/model/data-dictionary/validators/NumberGreaterThanValidator");
/**
 * Validator sets for promo settings
 * @author Tomáš Leity
 */


var PromoSettingsValidatorSets =
/*#__PURE__*/
function () {
  function PromoSettingsValidatorSets() {
    _classCallCheck(this, PromoSettingsValidatorSets);
  }

  _createClass(PromoSettingsValidatorSets, null, [{
    key: "getNumberValidators",

    /**
     * Getter for number validators
     */
    get: function get() {
      return [new IntegerValidator_1.IntegerValidator(), new NumberGreaterThanValidator_1.NumberGreaterThanValidator(0, true)];
    }
  }]);

  return PromoSettingsValidatorSets;
}();

exports.PromoSettingsValidatorSets = PromoSettingsValidatorSets;